module.exports = __webpack_public_path__ + "media/images/features/6/og-image-9a9001ce3e0f0d75ae0cb86a0395ac6d.jpg";